module.exports = __webpack_public_path__ + "img/2.0b1f4548.jpg";